<template>
    <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
        <div class="page_header">
            <span class="page_title">{{ $t('行程统计.page_title') }}</span>
            <div style="flex:1;text-align: right;">
                <quickQuery :isDownload="false" @handleQuery="onQuery" @quickQuery="onQuery"   style="text-align: right"/>
              

            </div>

        </div>
        <el-divider></el-divider>
        <div class="page_container">
            <div>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <div style="background: #E8F0FF;border: 1px solid #D9E4F8;height: 260px;">
                            <el-row style="height: 100%;">
                                <el-col :span="8" style="height: 100%;">
                                    <div style="padding: 20px;">
                                        <div style="font-size: 14px;color: #0F1A3A;font-weight: bold;">{{
                                            $t('行程统计.油车统计') }}</div>
                                        <div style="text-align: center;margin-top: 55px;">
                                            <img src="@/assets/images/ic_youliang.png" alt=""
                                                style="width: 60px;height: 60px;">
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="8" style="display: flex;flex-direction: column;height: 100%;">

                                    <schedule_statistics_item :title="$t('行程统计.行程数')" :value="briefData.OilTripCount?briefData.OilTripCount:'--'"
                                        unit="Trips"
                                        style="border-left: 1px solid #D9E4F8;border-bottom: 1px solid #D9E4F8;flex: 1;" />
                                    <schedule_statistics_item :title="$t('行程统计.平均百公里能耗')"
                                        :value="briefData.OilAvgConsume?briefData.OilAvgConsume:'--'" unit="L/100km"
                                        style="border-left: 1px solid #D9E4F8;flex: 1;" />
                                </el-col>
                                <el-col :span="8" style="display: flex;flex-direction: column;height: 100%;">
                                    <schedule_statistics_item :title="$t('行程统计.总里程')" :value="briefData.OilMileage?briefData.OilMileage:'--'"
                                        unit="km"
                                        style="border-left: 1px solid #D9E4F8;border-bottom: 1px solid #D9E4F8;flex: 1;" />
                                    <schedule_statistics_item :title="$t('行程统计.事件数量')"
                                        :value="briefData.OilBadDrivingCount?briefData.OilBadDrivingCount:'--'" unit="个"
                                        style="border-left: 1px solid #D9E4F8;flex: 1;" />
                                </el-col>
                            </el-row>

                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div style="background: #E8F0FF;border: 1px solid #D9E4F8;height: 260px;">
                            <el-row style="height: 100%;">
                                <el-col :span="8">
                                    <div style="padding: 20px;">
                                        <div style="font-size: 14px;color: #0F1A3A;font-weight: bold;">{{
                                            $t('行程统计.电车统计') }}</div>
                                        <div style="text-align: center;margin-top: 60px;">
                                            <img src="@/assets/images/ic_dianliang.png" alt=""
                                                style="width: 60px;height: 60px;">
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="8" style="display: flex;flex-direction: column;height: 100%;">
                                    <schedule_statistics_item :title="$t('行程统计.行程数')" :value="briefData.ElecTripCount?briefData.ElecTripCount:'--'"
                                        unit="Trips"
                                        style="border-left: 1px solid #D9E4F8;border-bottom: 1px solid #D9E4F8;flex: 1;" />
                                    <schedule_statistics_item :title="$t('行程统计.平均百公里能耗')"
                                        :value="briefData.ElecAvgConsume?briefData.ElecAvgConsume:'--'" unit="kW·h/100km"
                                        style="border-left: 1px solid #D9E4F8;flex: 1;" />
                                </el-col>
                                <el-col :span="8" style="display: flex;flex-direction: column;height: 100%;">
                                    <schedule_statistics_item :title="$t('行程统计.总里程')" :value="briefData.ElecMileage?briefData.ElecMileage:'--'"
                                        unit="km"
                                        style="border-left: 1px solid #D9E4F8;border-bottom: 1px solid #D9E4F8;flex: 1;" />
                                    <schedule_statistics_item :title="$t('行程统计.事件数量')"
                                        :value="briefData.ElecBadDrivingCount?briefData.ElecBadDrivingCount:'--'" unit="个"
                                        style="border-left: 1px solid #D9E4F8;flex: 1;" />
                                </el-col>
                            </el-row>

                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div style="background: #E8F0FF;border: 1px solid #D9E4F8;padding:20px;height: 260px;">
                            <div style="font-size: 14px;color: #0E193B;font-weight: bold;">{{ $t('行程统计.行程里程分布') }}</div>
                            <div class="chart-container">
                                <div class="chart-container" ref="chart" style="width: 100%; height: 200px;"></div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div style="margin-top: 20px;">
                <!--表格数据-->
                <el-table v-loading="loading" :data="tableData" border style="width: 100%" size="small">
                    <el-table-column :label="$t('行程统计.车辆')" prop="CarNo" align="center" />

                    <el-table-column :label="$t('time.startTimeHolder')" prop="BeginTime" align="center">
                        <template slot-scope="scope">
                            {{ formatTimeT(scope.row.BeginTime) }}
                        </template>
                    </el-table-column>

                    <el-table-column :label="$t('time.endTimeHolder')" prop="EndTime" align="center">
                        <template slot-scope="scope">
                            {{ formatTimeT(scope.row.EndTime) }}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="起点" prop="startLocation" align="center" />
                    <el-table-column :label="$t('行程统计.终点')" prop="startLocation" align="center" /> -->
                    <el-table-column :label="$t('行程统计.里程(km)')" prop="Mileage" align="center" />
                    <el-table-column :label="$t('行程统计.时长(h)')" prop="RunDuration" align="center" />
                    <el-table-column :label="$t('行程统计.事件数量(次)')" prop="BadDrivingCount" align="center" />
                    <el-table-column :label="$t('行程统计.电耗(kw·h)')" prop="ElecConsume" align="center" />
                    <el-table-column :label="$t('行程统计.油耗(L)')" prop="OilConsume" align="center" />
                    <el-table-column :label="$t('public.Operation')" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleDetail(scope.row)">{{ $t('public.Detail')
                                }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- Element UI 分页 -->
                <kl-pagination style="margin-bottom: 10px;" :pageSize="form.PageSize" :total="total"
                    @current-change="pageChange" @size-change="sizeChange" :current-page.sync="form.PageNo">
                </kl-pagination>
            </div>
        </div>

        <detail ref="detail" />

    </div>
</template>
<script>
import schedule_statistics_item from "./components/schedule_statistics_item.vue"
// import * as echarts from 'echarts'
import detail from "./detail"
import quickQuery from '../components/generalOrQuickQuery.vue'
import { queryWebDigitalRec } from "@/http/vehicle";
import { formatTime } from "@/utils/longyi";
import { mapState } from 'vuex'
import settings from "@/settings";
export default {
    name: "scheduleIndex",
    components: {
        schedule_statistics_item, detail,quickQuery
    },
    data() {
        return {
            loading: false,
            value1: this.getTodayDate(),
            form: {
                PageNo: 1,
                PageSize: 10,
            },

            tableData: [

            ],
            briefData: {},
            currentPage: 1, // 当前页码
            pageSize: 5, // 每页条数
            total: 0,// 数据总条数，实际应根据真实数据长度或接口返回设置
            chart: null, // X 轴：里程区间
            xAxisData: ['0-10', '10-20', '20-50', '50-100', '>100'],
            // 系列数据：行程次数
            seriesData: [0, 0, 0, 0, 0],
            beginDate: "",
            endDate: "",


            // 保存 ECharts 实例（用于响应式resize）
        }
    },
    computed: {
        size() {
            return this.$store.getters.size
        },
        ...mapState({
            selectedVehicles: state => state.app.vehicles.selectedVehicles,
        }),
    },
    methods: {
        formatTimeT(time) {
            return formatTime(time)

        },
        getTodayDate() {
            //格式化为yyyy-MM-dd

            return [this.moment(new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000)).format('YYYY-MM-DD'), this.moment(new Date(new Date().getTime())).format('YYYY-MM-DD')]

        },
        onExport() {

        },
        onQuery(val) {
            
      this.beginDate = val.beginDate + " 00:00:00";
      this.endDate = val.endDate + " 23:59:59";

            //查询统计数据
            this.queryBriefData();
            //查询行程数据
            this.queryScheduleData();


        },
        getOperatorID() {
            //  return "1665";
            //  return "7544";
            return this.$store.getters.operatorID;
        },

        getVehicleIDs() {
            // return "155060";//,115166,150369 38287
            //获取选中的车辆ID
            let vehicles = "";
            for (let k = 0; k < this.selectedVehicles.length; k++) {
                if (this.selectedVehicles[k].treeLevel == 5) {
                    vehicles = vehicles + this.selectedVehicles[k].nodeValue + ",";
                }
            }
            if (vehicles == "") {

                return "";
            }

            return vehicles.substring(0, vehicles.length - 1);
        },
        queryScheduleData() {
            this.loading = true;

            queryWebDigitalRec({
                "OperatorID": this.getOperatorID(),
                "VehicleIDs": this.getVehicleIDs(),
                "BeginTime": this.beginDate,
                "EndTime": this.endDate,
                "Flag": 2,//
                "PageNo": this.form.PageNo,
                "PageSize": this.form.PageSize
            }).then(res => {
                console.log(res);
                //赋值
                this.loading = false;

                if (res && res.code == 200) {
                    this.tableData = res.tripRec;
                    //计算总条数
                    this.total = res.tripCount;
                }
            });
        },
        //查询统计数据
        queryBriefData() {
            queryWebDigitalRec({
                "OperatorID": this.getOperatorID(),
                "VehicleIDs": this.getVehicleIDs(),
                "BeginTime": this.beginDate,
                "EndTime": this.endDate,
                "Flag": 1
            }).then(res => {
                console.log(res);
                //赋值
                if (res && res.code == 200) {
                    this.briefData = res.briefData;
                    this.seriesData = [res.briefData.M_0_10, res.briefData.M_10_20, res.briefData.M_20_50, res.briefData.M_50_100, res.briefData.M_100];
                    this.initChart();
                }
            });
        },

        handleDetail(row) {

            this.$refs.detail.show(row.VehicleID, formatTime(row.BeginTime), formatTime(row.EndTime), row.OilType);

        },
        sizeChange(size) {
            this.form.PageSize = size;
            this.queryScheduleData();
        },
        pageChange(page) {
            this.form.PageNo = page;
            this.queryScheduleData();
        },
        initChart() {
            this.chart = echarts.init(this.$refs.chart);
            //柱状图

            const option = {
                grid: {
                    left: '5%',
                    right: '10%',
                    bottom: '5%',
                    top: '20%',
                    containLabel: true
                },
                yAxis: [{
                    type: 'category',
                    data: this.xAxisData,
                    name: this.$t('行程统计.行程里程(km)'), // X 轴名称
                    nameTextStyle: { fontSize: 14 }, // 名称样式
                    axisLabel: { fontSize: 12 } // 刻度文字大小
                },
                ],
                xAxis: {
                    type: 'value',
                    name: this.$t('行程统计.次数'), // Y 轴名称
                    nameTextStyle: { fontSize: 14 },
                    axisLabel: { fontSize: 12 }
                },
                series: [
                    {
                        name: this.$t('行程统计.行程次数'),
                        type: 'bar', // 柱状图
                        data: this.seriesData,
                        barWidth: 15,
                        itemStyle: {
                            color: '#4286F4' // 柱子颜色（接近示例的蓝色）
                        },
                        label: {
                            show: true, // 显示柱子顶部的数值标签
                            position: 'right',
                            color: '#333' // 标签颜色
                        }
                    },

                ]
            }

            this.chart.setOption(option)

        },
        handleResize() {
            if (this.chart) {
                this.chart.resize()
            }
        }
    },

    mounted() {
         const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }
        this.initChart();
        // this.onQuery();
        window.addEventListener('resize', this.handleResize) // 监听窗口变化
    },
    //界面显示的时候
    activated() {
        this.handleResize();
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize) // 销毁前移除监听
    },

}
</script>